import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import { employeeCertificateFragment } from '../fragments/EmployeeCertificateFragment'
import type {
  CreateEmployeeCertificateMutation,
  CreateEmployeeCertificateMutationVariables
} from './__generated__/CreateEmployeeCertificateMutation'

const mutation: TypedDocumentNode<
  CreateEmployeeCertificateMutation,
  CreateEmployeeCertificateMutationVariables
> = gql`
  ${employeeCertificateFragment}

  mutation CreateEmployeeCertificateMutation(
    $input: CreateEmployeeCertificateInput!
  ) {
    createEmployeeCertificate(input: $input) {
      certificate {
        ...EmployeeCertificateFragment
      }
    }
  }
`

export function createEmployeeCertificateMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      CreateEmployeeCertificateMutation,
      CreateEmployeeCertificateMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
